import { AppError } from "config/errors";
import {
  createApplicationReferralMutation,
  ICreateApplicationReferralInput,
} from "gql/mutations/producerManagement";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const createApplicationReferral = createAsyncThunk(
  "producerManagement/createApplicationReferral",
  async (input: ICreateApplicationReferralInput, { rejectWithValue }) => {
    try {
      const { data } = await createApplicationReferralMutation(input);

      return data.createApplicationReferral.response;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  },
  {
    condition: input => {
      const { referralCode } = input;

      if (!referralCode) {
        return false;
      }
    },
  }
);
